import React from "react";

function LoadingState({ label }) {
  return (
    <div className="loading-state">
      <div className="spinner-border text-primary me-3" role="status" />
      <span>{label || "Loading..."}</span>
    </div>
  );
}

export default LoadingState;
